


// import React from "react";
// import { Box } from "@mui/material";
// import logo from "../../images/kar_main_logo.png"

// export const AuthInfoBox = () => {
//   return (
//     <Box sx={{ maxWidth: "60%", minWidth: "60%", display: { xs: "none", md: "block" }, mt: 8, mb: 3, display: "flex", justifyContent: "center" }}>
//       <img 
//         src={logo}
//         alt="Description of image" 
//         style={{ maxWidth: "100%", height: "auto" }} 
//       />
//     </Box>
//   );
// };


import { Box } from '@mui/material';
import logo from "../../images/kar_main_logo.png"

export const AuthInfoBox = () => {
  return (
    <Box 
      sx={{ 
        maxWidth: "60%", 
        minWidth: "60%", 
        mt: 8, 
        mb: 3, 
        display: { xs: "none", md: "flex" }, 
        justifyContent: "center" 
      }}
    >
      <img 
        src={logo}
        alt="Description of image" 
        style={{ maxWidth: "100%", height: "auto" }} 
      />
    </Box>
  );
};



